import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface ApimoAgencyUser {
  id: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  picture: string | null;
}

async function listApimoAgencyUsers(
  agencyId: string,
  auth: Authentication | null
): Promise<ApimoAgencyUser[]> {
  try {
    const res = await HttpClient.get(`/integrations/apimo/agencies/${agencyId}/users`, auth?.token);
    if (res.success) {
      return res.data as ApimoAgencyUser[];
    }
    return [];
  } catch (e) {
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new ListApimoAgencyUsersFailure('Le serveur ne répond pas');
    }
    throw new ListApimoAgencyUsersFailure(
      `Impossible de récupérer les agents de l'agence ${agencyId} : ${e instanceof Error ? e.message : 'erreur inconnue'}`,
      '400'
    );
  }
}

export class ListApimoAgencyUsersFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default listApimoAgencyUsers;
